export default __webpack_public_path__ + "1385a3ee4ef5758a74a00283047e8252.svg";